export default __webpack_public_path__ + "static/app-dev-card-01-8aa75e7838def8c348e2a4a8d60a4ef4.svg";